<div
  [ngClass]="getTileClasses()"
  (click)="onNotificationClick()"
  [attr.data-testid]="'notification-tile'"
  [attr.aria-label]="'Notification: ' + notification.title">

  <!-- Notification Icon -->
  <div 
    class="notification-icon" 
    [ngClass]="getNotificationColor()"
    [attr.data-testid]="'notification-icon'"
    [attr.data-type]="notification.type">
    <mat-icon>{{ getNotificationIcon() }}</mat-icon>
  </div>

  <!-- Notification Content -->
  <div class="notification-content">
    
    <!-- Header with title and timestamp -->
    <div class="notification-header">
      <span 
        class="notification-title" 
        [attr.data-testid]="'notification-title'">
        {{ notification.title }}
      </span>
      <span 
        class="notification-time" 
        [attr.data-testid]="'notification-time'">
        {{ getTimeAgo() }}
      </span>
    </div>


    <!-- Message content -->
    <div 
      class="notification-message" 
      [attr.data-testid]="'notification-message'">
      {{ getTruncatedMessage() }}
    </div>

    <!-- Action indicator (if notification has action URL) -->
    <div class="notification-footer" *ngIf="hasActionUrl()">
      <span class="action-indicator">
        <mat-icon>open_in_new</mat-icon>
        <span>Tap to view details</span>
      </span>
    </div>

    <!-- Additional data preview (for development) -->
    <div class="notification-data" *ngIf="fromUser">
      <details class="data-details">
        <summary>From: {{ fromUser.firstName + ' ' + fromUser.lastName }}</summary>
      </details>
    </div>

  </div>

  <!-- Action buttons -->
  <div class="notification-actions">
    
    <!-- Unread indicator -->
    <div 
      class="unread-indicator" 
      *ngIf="isUnread()"
      [attr.data-testid]="'unread-indicator'"
      aria-label="Unread notification">
    </div>


    <!-- Delete button -->
<!--    <button -->
<!--      mat-icon-button-->
<!--      (click)="onDelete($event)"-->
<!--      matTooltip="Delete notification"-->
<!--      class="action-button delete-button"-->
<!--      [attr.data-testid]="'delete-button'"-->
<!--      aria-label="Delete notification">-->
<!--      <mat-icon>delete</mat-icon>-->
<!--    </button>-->

  </div>

</div>